const { createSlice } = require('@reduxjs/toolkit');
const { getApplication } = require('shared/redux/applicationSlice');
const { clearPlantDesignForm } = require('plantItemNew/redux/slices/formSlice');

const initialState = {
  registrationType: undefined,
  firstName: undefined,
  midddleName: undefined,
  lastName: undefined,
  emailAddress: undefined,
  contactMethod: undefined,
};

const plantDesignRegistrationHolderSlice = createSlice({
  name: 'plantDesignHolderDetails',
  initialState,
  reducers: {
    storePlantDesignHolderDetails(state, action) {
      const holderDetails = action.payload;
      return { ...holderDetails };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantDesignHolderDetails };
      });
  },
});

export const { storePlantDesignHolderDetails } = plantDesignRegistrationHolderSlice.actions;
export const plantDesignRegistrationHolderReducer = plantDesignRegistrationHolderSlice.reducer;
